/* Owned bpl-remodel sizing-chart viewer; native Fancybox remains the viewer. */
(() => {
  'use strict';
  if (window.BPLRemodelChartViewer) {
    window.BPLRemodelChartViewer.init(document);
    return;
  }
  // Fancybox already delegates clicks to cloned chart anchors. This one scoped
  // listener supplies accessible image/dialog names without rebinding its viewer.
  // The toolbar stays outside the transformed image. Observe native image
  // movement and sample only during its transitions; no idle animation loop.
  let chartToolbarPlacement = null;
  function placeChartToolbar(instance, slide) {
    if (chartToolbarPlacement && chartToolbarPlacement.instance === instance && chartToolbarPlacement.slide === slide) {
      chartToolbarPlacement.schedule();
      return;
    }
    if (chartToolbarPlacement) chartToolbarPlacement.stop();
    const image = slide.$image && slide.$image[0];
    const content = slide.$content && slide.$content[0];
    const container = instance.$refs && instance.$refs.container && instance.$refs.container[0];
    const toolbar = container && container.querySelector('.fancybox-toolbar');
    if (!image || !content || !container || !toolbar) return;
    let frame = 0;
    let stopped = false;
    const observer = new MutationObserver(schedule);
    const tracker = { instance, slide, schedule, stop };
    function stop() {
      if (stopped) return;
      stopped = true;
      observer.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener('resize', schedule);
      if (chartToolbarPlacement === tracker) chartToolbarPlacement = null;
    }
    function schedule() {
      if (!stopped && !frame) frame = window.requestAnimationFrame(update);
    }
    function update() {
      frame = 0;
      if (stopped) return;
      if (instance.isClosing || instance.current !== slide || !image.isConnected || !container.isConnected) {
        stop();
        return;
      }
      const picture = image.getBoundingClientRect();
      const overlay = container.getBoundingClientRect();
      const parent = (toolbar.offsetParent || container).getBoundingClientRect();
      const viewport = {
        left: Math.max(0, overlay.left), top: Math.max(0, overlay.top),
        right: Math.min(window.innerWidth, overlay.right), bottom: Math.min(window.innerHeight, overlay.bottom)
      };
      const visible = {
        left: Math.max(viewport.left, picture.left), top: Math.max(viewport.top, picture.top),
        right: Math.min(viewport.right, picture.right), bottom: Math.min(viewport.bottom, picture.bottom)
      };
      const width = toolbar.offsetWidth;
      const height = toolbar.offsetHeight;
      if (width && height && visible.right > visible.left && visible.bottom > visible.top) {
        const left = Math.max(viewport.left + 8, Math.min(visible.right - width - 8, viewport.right - width - 8)) - parent.left;
        const top = Math.max(viewport.top + 8, Math.min(visible.top + 8, viewport.bottom - height - 8)) - parent.top;
        const leftValue = Math.round(left * 100) / 100 + 'px';
        const topValue = Math.round(top * 100) / 100 + 'px';
        if (toolbar.style.right !== 'auto') toolbar.style.right = 'auto';
        if (toolbar.style.left !== leftValue) toolbar.style.left = leftValue;
        if (toolbar.style.top !== topValue) toolbar.style.top = topValue;
      }
      // Fancybox removes the inline duration when native zoom/pan inertia ends.
      if (instance.isAnimating || parseFloat(content.style.transitionDuration) > 0) schedule();
    }
    chartToolbarPlacement = tracker;
    observer.observe(content, { attributes: true, attributeFilter: ['style'] });
    window.addEventListener('resize', schedule, { passive: true });
    schedule();
  }
  let chartViewerBound = false;
  function bindChartViewer(scope) {
    if (chartViewerBound || !scope.querySelector || !scope.querySelector('[data-bpl-remodel-details] [data-bpl-size-chart-zoom]')) return;
    const $ = window.jQuery;
    if (!$ || !$.fancybox) return;
    $(document).on('afterShow.fb.bplRemodelChart', (_event, instance, slide) => {
      const origin = slide && slide.opts && slide.opts.$orig;
      const trigger = origin && origin[0];
      if (!trigger || !trigger.matches('[data-bpl-remodel-details] [data-bpl-size-chart-zoom]')) return;
      const image = trigger.querySelector('img');
      if (slide.$image) slide.$image.attr('alt', image && image.getAttribute('alt') || '');
      if (instance.$refs && instance.$refs.container) instance.$refs.container.attr({ 'aria-label': 'Sizing chart', 'aria-modal': 'true' });
      // Use this document's CSS viewport, including the editor's Mobile iframe.
      // Each newly opened chart starts at real pixels once; manual Zoom out stays.
      const viewerImage = slide.$image && slide.$image[0];
      if (typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 798px)').matches
          && instance.current === slide && !instance.isClosing && !instance.isAnimating
          && slide.type === 'image' && slide.isLoaded && !slide.hasError && !slide.bplChartMobileZoomed
          && trigger.isConnected && viewerImage && viewerImage.isConnected && viewerImage.complete
          && viewerImage.naturalWidth > 0 && viewerImage.naturalHeight > 0
          && typeof instance.isScaledDown === 'function' && typeof instance.scaleToActual === 'function'
          && instance.isScaledDown()) {
        slide.bplChartMobileZoomed = true;
        instance.scaleToActual();
      }
      placeChartToolbar(instance, slide);
    });
    $(document).on('beforeClose.fb.bplRemodelChart afterClose.fb.bplRemodelChart', (_event, instance) => {
      if (chartToolbarPlacement && chartToolbarPlacement.instance === instance) chartToolbarPlacement.stop();
    });
    chartViewerBound = true;
  }

  window.BPLRemodelChartViewer = { init: bindChartViewer };
  // Handles an asset arriving after the section was already enhanced.
  // Earlier loads are bound by the section's normal init after enhancement.
  bindChartViewer(document);
})();
